<template>

    <v-modal title="Apply Styles?">
        <template #body>
            <p>Are you sure you want to apply this block’s styles to similar blocks?</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="dismiss">Cancel</v-button>
            <v-button size="sm" @click.native="submit">Apply Styles</v-button>
        </template>
    </v-modal>

</template>

<script>

import BuilderUtil from '@builder/utils/BuilderUtil';
import Modal from './Modal';

export default {

    components: {
        'v-modal': Modal,
    },

    methods: {

        submit() {
            let blocks = this.$store.getters['builder/blocks'];
            let selectedBlock = this.$store.getters['builder/selectedBlock'];
            // Generate new blocks.
            let newBlocks = [];
            blocks.forEach(block => {
                if (block.type === selectedBlock.type) {
                    let params = JSON.parse(JSON.stringify(selectedBlock));
                    delete params.alt;
                    delete params.link;
                    delete params.src;
                    delete params.text;
                    block = Object.assign(block, params);
                }
                newBlocks.push(block);
            });
            this.$store.commit('builder/setBlocks', newBlocks);
            // Update the styles of all relevant blocks.
            for (let i = 0; i < blocks.length; i++) {
                if (blocks[i].type === selectedBlock.type) {
                    BuilderUtil.updateBlockElementAtIndex(i);
                }
            }
            // Dismiss.
            this.dismiss();
        },

        dismiss() {
            this.$store.commit('builder/setSelectedModal', null);
        },

    },

}

</script>